import { styled } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { useState, useEffect, createElement } from 'react';
import '../utilities/get-styleprop.js';
import { _ as _objectWithoutProperties, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../ErrorLabel/ErrorLabel.js';
import '../FormItem/FormItem.js';
import '../Input/Input.js';
import '../InputLabel/InputLabel.js';
import TextInput from '../TextInput/TextInput.js';
import InputAddon from '../InputAddon/InputAddon.js';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import Button from '../Button/Button.js';

const Container = styled(Div)`
  & input::-ms-reveal {
    display: none;
  }
`;

const _excluded = ["type", "buttonProps"];
const PasswordInput = _ref => {
  let {
      type = 'password',
      buttonProps
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [inputType, setInputType] = useState(type);
  const isPasswordType = inputType === 'password';
  useEffect(() => {
    setInputType(type);
  }, [type]);
  const handleOnClick = () => setInputType(isPasswordType ? 'text' : 'password');
  return /*#__PURE__*/createElement(Container, null, /*#__PURE__*/createElement(TextInput, _extends({
    type: inputType,
    endInputAddon: /*#__PURE__*/createElement(InputAddon, {
      position: "end",
      size: props.size
    }, /*#__PURE__*/createElement(Button, _extends({
      role: "button",
      "aria-pressed": isPasswordType ? 'true' : 'false',
      iconProps: {
        glyph: isPasswordType ? icons.EYE : icons.EYE_OFF
      },
      onClick: handleOnClick,
      small: true,
      shape: "circle",
      variant: "tertiary",
      styles: {
        root: {
          p: 0
        }
      }
    }, buttonProps)))
  }, props)));
};

export { PasswordInput };
